"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonCta = require("@mmc/common-cta");

var _text = require("@mmc/text");

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _infoHeader = require("./info-header.propTypes");

var _infoHeader2 = _interopRequireDefault(require("./info-header.css"));

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;

var setLowerCase = function setLowerCase(str) {
  return str.toLowerCase();
};

var setTab = function setTab(icon) {
  return icon === 'laptop';
};

var setLink = function setLink(icon) {
  switch (icon) {
    case 'phone':
      return 'tel:';

    case 'email':
      return 'mailto:';

    default:
      return '';
  }
};

var publishPhoneEmailClickToDataLayer = function publishPhoneEmailClickToDataLayer(contactType, label, market) {
  if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
    if (contactType === 'phone') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'phone_click',
        comp_page: {
          phone_ctc: parseInt(label.replaceAll(' ', ''), 10)
        }
      });
    }

    if (contactType === 'email') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'email_click',
        comp_page: {
          mail_to: label.toLowerCase()
        }
      });
    }
  }
};

var createLink = function createLink(data, theme, config) {
  var icon = setLowerCase(data.icon);
  var market = config.market;

  if (icon !== 'phone' && icon !== 'email' && icon !== 'laptop' && icon !== 'facebooksquare' && icon !== 'instagram' && icon !== 'linkedin' && icon !== 'pinterest' && icon !== 'youtube') {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: _infoHeader2["default"].featureNumber + " " + (data.icon && theme["mmcIcon" + data.icon]) + " " + theme.bodyCopy
    }, handleNestedProp(data, 'data.description'));
  }

  return /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: {
      url: "" + setLink(icon) + handleNestedProp(data, 'data.description'),
      label: handleNestedProp(data, 'data.description'),
      openNewTab: setTab(icon),
      priority: 'lowIcon',
      icon: handleNestedProp(data, 'data.icon')
    },
    classes: [_infoHeader2["default"].featureNumber],
    mouseDownEvent: function mouseDownEvent() {
      return publishPhoneEmailClickToDataLayer(icon, handleNestedProp(data, 'data.description'), market);
    }
  });
};

var FeatureBlock = function FeatureBlock(_ref) {
  var data = _ref.data,
      theme = _ref.theme,
      config = _ref.config;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: handleNestedProp(data, 'data.title'),
    className: (0, _clsx["default"])(theme.marginBottom5, theme.headingFive),
    tag: "h3",
    automation: "featureTitle",
    disclaimerData: data.disclaimerData,
    disclaimerButtonSpacing: "0px"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme.row, _infoHeader2["default"].featureNumberWrapper)
  }, createLink(data, theme, config)));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(FeatureBlock));

exports["default"] = _default;